import { AudioControlWrapper as AudioControl } from '../../session/controls/AudioControlWrapper';
import { useOpenHelpModalCallback } from '../useOpenHelpModalCallback';

export function VisitorAudioControlWrapper() {
  const openHelpModal = useOpenHelpModalCallback();

  return <AudioControl openHelpModal={openHelpModal} />;
}
